module.exports = __webpack_public_path__ + "static/media/view-block-active.be9a936b.svg";